module.exports = __webpack_public_path__ + "img/logo_samll.51d83708.jpg";